import { Component, ViewChild } from '@angular/core';
import {NavController, NavParams, Content, ViewController, ModalController} from 'ionic-angular';
import { MessagingProvider } from '../../../providers/messaging/messaging';
import {ProfilePage} from "../profile/profile";


@Component({
  selector: 'page-message',
  templateUrl: 'message.html',
})
export class MessagePage {
  messages: any[] = [];
  typingMessage: string = '';
  recipient:string = '';
  @ViewChild(Content) content: Content;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public messagingProvider: MessagingProvider,
              private viewCtrl: ViewController,
              private modalCtrl: ModalController) {
    this.recipient = this.navParams.get('recipient');
    this.init();
  }


  init() {
    this.getMessages()
  }

  getMessages(){
    this.messagingProvider.getMessages({recipient_id: this.recipient[0]}).subscribe((res) => {
      this.messages.length = 0;
      if(res.success){
        res.data.forEach(msg => {

          if(msg.author_id == this.recipient[0]){
            msg.isMe = false
          }else{
            msg.isMe = true;
          }

          this.messages.push({
            isMe : msg.isMe,
            avatar : 'assets/img/mike.png',
            type: 'text',
            body: msg.content,
            timestamp: msg.createdAt
          })

        });
      }
      this.scrollBottom();
    })
  }

  sendText() {
    let message = {
      recipient_id: this.recipient[0],
      content: this.typingMessage,
    }
    this.messagingProvider.sendMessage(message).subscribe((res) => {
      if(res.success){
        this.init();
      }
    })
    this.messages.length = 0; // clear array
    this.getMessages();
    this.typingMessage = '';

  }

  scrollBottom() {
    this.content.resize();
    this.content.scrollTo(0, this.content.scrollHeight, 350);
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  goToProfile() {
    this.modalCtrl.create(ProfilePage, {userId : this.recipient[0]}).present().then(() => {});
  }


}



// WEBPACK FOOTER //
// ./src/pages/employee/message/message.ts